module.exports = __webpack_public_path__ + "static/media/SUEZ Cookie Policy.0e6add58.pdf";